<template>
  <div class="alert alert-dark mb-5">
    <!--<div class="form-group row mb-4">
            <label class="col-sm-4">Mire kíván szerződést kötni?</label>
            <div class="col-sm-8">
                <div class="btn w-100 btn-red" style="cursor: unset" v-if="$store.state.generalInfo.contractFor == 1">Ingatlan és ingóság</div>
                <div class="btn w-100 btn-red" style="cursor: unset" v-if="$store.state.generalInfo.contractFor == 2">Csak ingatlan</div>
                <div class="btn w-100 btn-red" style="cursor: unset" v-if="$store.state.generalInfo.contractFor == 3">Csak ingóság</div>
            </div>
        </div>
        <div v-if="$store.state.page >= 3">
            <div class="form-group row mb-4">
                <label class="col-sm-4">Kiegészítőkkel megemelt éves díj</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" readonly :value="$store.state.kieg_emelt_eves_dij | currency">
                </div>
            </div>
            <div class="form-group row mb-4">
                <label class="col-sm-4">Kedvezményekkel csökkentett díj</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" readonly :value="$store.state.kieg_kedv_dij | currency">
                </div>
            </div>
            <div class="form-group row mb-4">
                <label class="col-sm-4">Gyakoriság szerinti díj</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" readonly :value="($store.state.gyakorisag_szerint_fizetendo_dij > $store.state.gyakorisag_dij_min ? $store.state.gyakorisag_szerint_fizetendo_dij : $store.state.gyakorisag_dij_min) | currency">
                </div>
            </div>
        </div>-->
    <h1 class="h2 text-white">
      Az ön által megadott adatok alapján biztosítása az alábbi összegeket
      tartalmazza:
    </h1>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label for="main-building" class="col-sm-6">Főépület:</label>
          <div class="col-sm-6">
            <input
              id="main-building"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.generalInfo.contractFor !== 3
                  ? $store.state.insuranceProperty.chosenInsurancePrice
                  : 0 | currency
              "
            />
          </div>
        </div>
        <div
          class="form-group row mb-4"
          v-if="
            $store.state.insuranceSideBuildings.list.length > 0 &&
              $store.state.generalInfo.contractFor !== 3
          "
        >
          <label for="side-building" class="col-sm-6">Melléképület(ek):</label>
          <div class="col-sm-6">
            <input
              id="side-building"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.insuranceSideBuildings.chosenInsurancePrice
                  | currency
              "
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group row mb-2">
          <label for="main-building-goods" class="col-sm-6"
            >Főépület ingóság:</label
          >
          <div class="col-sm-6">
            <input
              id="main-building-goods"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.generalInfo.contractFor !== 2
                  ? mainPropertyInsurance
                  : 0 | currency
              "
            />
          </div>
        </div>
        <div
          class="form-group row mb-4"
          v-if="$store.state.insuranceSideBuildings.list.length > 0"
        >
          <label for="side-building-goods" class="col-sm-6"
            >Melléképület(ek) ingóság:</label
          >
          <div class="col-sm-6">
            <input
              id="side-building-goods"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.insurancePersonalGoods.sideBuildingsGoodsPrice
                  | currency
              "
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label for="yearly-base-price" class="col-sm-6 fw-bold"
            >A biztosítás éves alapdíja:</label
          >
          <div class="col-sm-6">
            <input
              id="yearly-base-price"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.chooseableAccesories.accessorySumPrice | currency
              "
            />
          </div>
        </div>
        <div class="form-group row mb-2" v-if="$store.state.page > 2">
          <label for="accessories-total-price" class="col-sm-6 fw-bold"
            >A kiegészítők díja összesen:</label
          >
          <div class="col-sm-6">
            <input
              id="accessories-total-price"
              type="text"
              class="form-control"
              disabled
              :value="$store.state.eves_dij_plus | currency"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" v-if="$store.state.page >= 3">
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold text-sm-end">Pótdíjak:</label>
        </div>
        <div class="form-group row mb-2" v-if="$store.state.engedmenyek.csekk">
          <label for="postal-check" class="col-sm-6 text-sm-end"
            >Postai csekk:</label
          >
          <div class="col-sm-6">
            <input
              id="postal-check"
              type="text"
              class="form-control"
              disabled
              :value="$store.state.engedmenyek.csekk | currency"
            />
          </div>
        </div>
        <div class="form-group row mb-2" v-if="$store.state.engedmenyek.havi">
          <label for="monthly-payment-frequency" class="col-sm-6 text-sm-end"
            >Havi díjfizetési gyakoriság:</label
          >
          <div class="col-sm-6">
            <input
              id="monthly-payment-frequency"
              type="text"
              class="form-control"
              disabled
              :value="$store.state.engedmenyek.havi | currency"
            />
          </div>
        </div>

        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold text-sm-end">Kedvezmények:</label>
        </div>
        <div class="form-group row mb-2">
          <label for="electroinc-communication" class="col-sm-6 text-sm-end"
            >Elektronikus kommunikáció:</label
          >
          <div class="col-sm-6">
            <input
              id="electroinc-communication"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.engedmenyek.elektronikus_kommunikacio | currency
              "
            />
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="e-claim-adjustment" class="col-sm-6 text-sm-end"
            >Elektronikus kárrendezés:</label
          >
          <div class="col-sm-6">
            <input
              id="e-claim-adjustment"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.engedmenyek.elektronikus_karrendezes | currency
              "
            />
          </div>
        </div>
        <div
          class="form-group row mb-2"
          v-if="$store.state.engedmenyek.fizetesi_mod_kedvezmeny"
        >
          <label for="payment-method" class="col-sm-6 text-sm-end"
            >Fizetési mód:</label
          >
          <div class="col-sm-6">
            <input
              id="payment-method"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.engedmenyek.fizetesi_mod_kedvezmeny | currency
              "
            />
          </div>
        </div>
        <div
          class="form-group row mb-2"
          v-if="$store.state.engedmenyek.dijfizetes_gyakorisag_kedvezmeny"
        >
          <label for="payment-frequency" class="col-sm-6 text-sm-end"
            >Díjfizetési gyakoriság:</label
          >
          <div class="col-sm-6">
            <input
              id="payment-frequency"
              type="text"
              class="form-control"
              disabled
              :value="
                $store.state.engedmenyek.dijfizetes_gyakorisag_kedvezmeny
                  | currency
              "
            />
          </div>
        </div>

        <div class="form-group row mb-2">
          <label for="total-annual-premium" class="col-sm-6 fw-bold"
            >A biztosítás éves díja összesen:</label
          >
          <div class="col-sm-6">
            <input
              id="total-annual-premium"
              type="text"
              class="form-control"
              disabled
              :value="$store.state.kieg_emelt_eves_dij | currency"
            />
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="chosen-payment-frequency" class="col-sm-6 fw-bold"
            >Az Ön által választott díjfizetési gyakoriság szerinti díj:</label
          >
          <div class="col-sm-6">
            <input
              id="chosen-payment-frequency"
              type="text"
              class="form-control"
              disabled
              :value="paymentFrequentString"
            />
          </div>
        </div>
      </div>
    </div>
    <small>
      A biztosítás éves alapdíja a következő lépésekben megadott adatok alapján
      módosulhat a pótdíjak és/vagy kedvezmények mértékével. A biztosítás éves
      díja minimum 8.000 Ft lehet.
    </small>
    <!-- <div class="ms-auto w-md-auto mt-2" v-if="$store.state.igeny_azon_href">
      <a
        :href="$store.state.igeny_azon_href"
        target="_blank"
        class="btn btn-red w-100 w-md-auto claim-identifier"
        >Igényazonosító letöltése</a
      >
    </div> -->
    <RequestPdfButton :showFromPage="4"></RequestPdfButton>
  </div>
</template>

<script>
import { parse as parseMoney } from "vue-currency-input";
import RequestPdfButton from "./components/components/RequestPdfButton.vue";

export default {
  components: {
    RequestPdfButton,
  },
  data() {
    return {
      summaryPrice: 0,
    };
  },
  watch: {
    "$store.state.insurancePersonalGoods.summaryInputs": {
      deep: true,

      handler(data) {
        this.calculateSummaryPrice(data);
      },
    },
  },
  computed: {
    mainPropertyInsurance() {
      const acceptInsurance = this.$store.state.insurancePersonalGoods
        .acceptCalculatedInsurance;

      if (acceptInsurance)
        return this.$store.state.insurancePersonalGoods
          .calculatedInsurancePrice;

      const insuranceType = this.$store.state.insurancePersonalGoods.priceType;
      if (insuranceType == "full")
        return this.$store.state.insurancePersonalGoods.allGoodsPrice;
      else return this.summaryPrice;
    },
    paymentFrequentString() {
      const frequency = this.$store.state.paymentOptions.frequency;
      let stringFrequency;
      if (frequency == "eves") stringFrequency = " /év";
      else if (frequency == "feleves") stringFrequency = " /félév";
      else if (frequency == "negyedeves") stringFrequency = " /negyedév";
      else stringFrequency = " /hó";
      return (
        this.$options.filters.currency(
          this.$store.state.gyakorisag_szerint_fizetendo_dij,
        ) + stringFrequency
      );
    },
  },
  methods: {
    calculateSummaryPrice(data) {
      let price = 0;
      for (const [key, value] of Object.entries(data)) {
        if (typeof value === "string") {
          const parsedInt = parseMoney(value, window.currencyInputOptions);
          if (parsedInt) price += parsedInt;
        }
      }
      this.summaryPrice = price;
    },
  },
  created() {
    this.calculateSummaryPrice(
      this.$store.state.insurancePersonalGoods.summaryInputs,
    );
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px) {
  .claim-identifier {
    max-width: max-content !important;
  }
}
</style>
